import { render, staticRenderFns } from "./CoursesSlider.vue?vue&type=template&id=81a44d72&scoped=true"
import script from "./CoursesSlider.vue?vue&type=script&lang=ts"
export * from "./CoursesSlider.vue?vue&type=script&lang=ts"
import style0 from "./CoursesSlider.vue?vue&type=style&index=0&id=81a44d72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a44d72",
  null
  
)

export default component.exports